import React from 'react'
import styles from './styles.module.css'
import caretDown from '../../../images/caretDownGeneric.svg'
import infoIconRegular from './../images/circle-info-regular-full.svg'
import Tooltip from '@mui/material/Tooltip'

function MostRecentSoldPrice ({ soldPriceFilter, setSoldPriceFilter }) {
  const handleSoldPriceValueChange = event => {
    const { name, value } = event.target
    const re = /^[0-9\b]+$/
    if (value === '' || re.test(value)) {
      setSoldPriceFilter(prevState => ({
        ...prevState,
        [name]: value,
        currency: prevState.currency || 'USD'
      }))
    }
  }

  const handleSoldCurrencyChange = event => {
    const { value } = event.target
    setSoldPriceFilter(prevState => ({
      ...prevState,
      currency: value
    }))
  }

  return (
    <div className={styles.RecentSoldContainer}>
      <div className={styles.sectionTitleWithIcon}>
        <span className={styles.spanPrice}>Most recent sold price</span>
        <Tooltip
          title='Filter by the most recent sold price (actual transaction price). Enter a minimum, maximum, or both to refine results.'
          arrow
          placement='top'
          slotProps={{
            popper: {
              sx: {
                '& .MuiTooltip-tooltip': {
                  maxWidth: 500,
                  fontSize: '13px',
                  padding: '8px'
                }
              }
            }
          }}
        >
          <img
            src={infoIconRegular}
            alt='Most recent sold price info'
            width={14}
            height={14}
            className={styles.infoIcon}
          />
        </Tooltip>
      </div>
      <div className={styles.inputPriceGroup}>
        <input
          autoComplete='off'
          className={styles.inputPrice}
          placeholder='Min'
          onChange={handleSoldPriceValueChange}
          value={soldPriceFilter.minValue || ''}
          name='minValue'
        />

        <input
          autoComplete='off'
          className={styles.inputPrice}
          placeholder='Max'
          onChange={handleSoldPriceValueChange}
          value={soldPriceFilter.maxValue || ''}
          name='maxValue'
        />
        <div style={{ marginRight: '32px' }}>
          <select
            className={styles.selectPrice}
            onChange={handleSoldCurrencyChange}
            value={soldPriceFilter.currency || 'USD'}
            name='currency'
          >
            <option value='USD'>USD</option>
            <option value='CAD'>CAD</option>
          </select>
          <img
            src={caretDown}
            alt='arrow'
            className={styles.customArrowPrice}
          />
        </div>
      </div>
    </div>
  )
}

export default MostRecentSoldPrice
